import SystemMessageItem from './SystemMessageItem';
import './SystemMessageItem.scss';

export default SystemMessageItem;
